<div aria-labelledby="Share custom report confirmation">
  <f-modal role="dialog" size="large" variant="dialog" position="center" [visible]="visible" aria-modal="true">
    
    <!-- Confirmation State -->
    @if (currentState === ShareModalState.CONFIRMATION) {
      <div style="margin-bottom: 12px">
        <h4>Share Custom Report?</h4>
      </div>
      <div>
        <p style="font-size: 15px;">
          You are about to share this custom report with all other users for the client domain.
        </p>
        <p style="font-size: 15px;">
          Do you want to proceed?
        </p>
      </div>
      <div class="modal-footer">
        <f-button type="button" variant="secondary" text="No" (buttonClicked)="onNoClicked()"></f-button>
        <f-button type="button" variant="action" text="Yes" (buttonClicked)="onYesClicked()"></f-button>
      </div>
    }

    <!-- Loading State -->
    @if (currentState === ShareModalState.LOADING) {
      <div style="margin-bottom: 12px">
        <h4>Sharing...</h4>
      </div>
      <div class="loading-container">
        <f-loading></f-loading>
      </div>
      <div class="modal-footer">
        <f-button type="button" variant="secondary" text="No" [disabled]="true"></f-button>
        <f-button type="button" variant="action" text="Yes" [disabled]="true"></f-button>
      </div>
    }

    <!-- Success State -->
    @if (currentState === ShareModalState.SUCCESS) {
      <div style="margin-bottom: 12px">
        <h4>Success</h4>
      </div>
      <div class="success-container">
        <div class="success-icon">
          <f-icon icon-config='{"iconName": "circle-check", "iconType": "solid"}'></f-icon>
        </div>
        <p style="font-size: 15px;">
          Your custom report has been shared successfully with all other users for the client domain.
        </p>
      </div>
      <div class="modal-footer">
        <f-button type="button" variant="action" text="Close" (buttonClicked)="onCloseClicked()"></f-button>
      </div>
    }

  </f-modal>
</div>
